import React, {useState, useEffect} from "react" ;

import ContactAppBody from "./Body/ContactAppBody";
import ContactAppSidebar from "./Sidebar/ContactAppSidebar";
import {useSetRecoilState} from "recoil";
import {selectedContact} from "root/recoil/selectedContact";
import {getContactDetails} from "root/DataFunctions/MessageDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

const WieldyApplicationModuleContact = (props) =>
{
    const [height, setHeight] = useState(props.height);
    const [width, setWidth] = useState(props.width);

    const pageStyle = {height: '' + (+height - 1) + 'px'};

    const user_id = props.match.params.user_id;

    const setSelectedContact = useSetRecoilState(selectedContact);

    const getData = () =>
    {
        console.log("Current User : " + props.match.params.user_id);

        getContactDetails(user_id, (response) =>
        {
            const contacts = getDataFromResponse(response);

            const first = contacts.length > 0 ? contacts[0] : {};

            setSelectedContact({record: first});
        });
    }

    useEffect(() => {
        getData();
    }, [props.match.params.user_id]);

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    return (
        <div className="row">
            <div className="col-xl-12">

                <div className="dt-module" style={pageStyle}>

                    {user_id != null && <ContactAppSidebar title={'Contact'} user_id={user_id} iconName={'icon-user-o'} height={props.height}/>}

                    {user_id != null && <ContactAppBody user_id={user_id} height={height} width={width}/>}

                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModuleContact;